
//export const BASE_URL = "http://13.200.216.166:3005/api"
 export const BASE_URL = 'https://catering-api.37nationalgamesgoa.in/api'
